export default __webpack_public_path__ + "static/media/6C.1f69ca79.svg";